import adminForgotPassword from './admin/forgot-password.svg';
import adminLogin from './admin/login.svg';
import businessuserForgotPassword from './businessuser/forgot-password.svg';
import businessuserLogin from './businessuser/login.svg';
import merchantBusinessAvatarBakery from './merchant/business-avatar-bakery.png';
import merchantBusinessAvatarCoffee from './merchant/business-avatar-coffee.png';
import merchantBusinessAvatarSpice from './merchant/business-avatar-spice.png';
import merchantBusinessAvatarTea from './merchant/business-avatar-tea.png';
import merchantBusinessDetailHero from './merchant/business-detail-hero.png';
import merchantBusinessMapPlaceholder from './merchant/business-map-placeholder.png';
import merchantDashboardUserAvatar from './merchant/dashboard-user-avatar.png';
import merchantForgotPassword from './merchant/forgot-password.svg';
import merchantLogin from './merchant/login.svg';
import merchantNotificationAvatarEmilyBlunt from './merchant/notifications/avatar-emily-blunt.png';
import merchantNotificationAvatarJamesWilson from './merchant/notifications/avatar-james-wilson.png';
import merchantNotificationAvatarMarcusAurelius from './merchant/notifications/avatar-marcus-aurelius.png';
import merchantNotificationAvatarSarahChen from './merchant/notifications/avatar-sarah-chen.png';
import merchantNudge1 from './merchant/nudge-1.png';
import merchantNudge2 from './merchant/nudge-2.png';
import merchantNudge3 from './merchant/nudge-3.png';
import merchantNudgePreviewPlaceholder from './merchant/nudge-preview-placeholder.png';
import merchantPhoneLoginHero from './merchant/phone-login-hero.png';
import merchantPost1 from './merchant/post-1.png';
import merchantPost2 from './merchant/post-2.png';
import merchantPost3 from './merchant/post-3.png';
import merchantSocialsEmptyIcons from './merchant/socials-empty-icons.png';
import merchantTeamEmptyAvatar1 from './merchant/team/team-empty-avatar-1.png';
import merchantTeamEmptyAvatar2 from './merchant/team/team-empty-avatar-2.png';
import merchantTeamEmptyAvatar3 from './merchant/team/team-empty-avatar-3.png';
import merchantTeamEmptyAvatar4 from './merchant/team/team-empty-avatar-4.png';

export const loginIllustrations = {
  admin: adminLogin,
  businessuser: businessuserLogin,
  merchant: merchantLogin,
};

export const forgotPasswordIllustrations = {
  admin: adminForgotPassword,
  businessuser: businessuserForgotPassword,
  merchant: merchantForgotPassword,
};

export const getLoginIllustration = (portalType) =>
  loginIllustrations[portalType] || loginIllustrations.admin;

export const getForgotPasswordIllustration = (portalType) =>
  forgotPasswordIllustrations[portalType] || forgotPasswordIllustrations.admin;

export const getMerchantPhoneLoginHero = () => merchantPhoneLoginHero;

export const getMerchantBusinessMapPlaceholder = () => merchantBusinessMapPlaceholder;

export const getMerchantBusinessDetailHero = () => merchantBusinessDetailHero;

export const getMerchantDashboardUserAvatar = () => merchantDashboardUserAvatar;

export const getMerchantBusinessAvatarCoffee = () => merchantBusinessAvatarCoffee;

export const getMerchantBusinessAvatarTea = () => merchantBusinessAvatarTea;

export const getMerchantBusinessAvatarBakery = () => merchantBusinessAvatarBakery;

export const getMerchantBusinessAvatarSpice = () => merchantBusinessAvatarSpice;

export const getMerchantNudgeImage1 = () => merchantNudge1;

export const getMerchantNudgeImage2 = () => merchantNudge2;

export const getMerchantNudgeImage3 = () => merchantNudge3;

export const getMerchantNudgePreviewPlaceholder = () => merchantNudgePreviewPlaceholder;

export const getMerchantPostImage1 = () => merchantPost1;

export const getMerchantPostImage2 = () => merchantPost2;

export const getMerchantPostImage3 = () => merchantPost3;

export const getMerchantNotificationAvatarSarahChen = () => merchantNotificationAvatarSarahChen;

export const getMerchantNotificationAvatarJamesWilson = () => merchantNotificationAvatarJamesWilson;

export const getMerchantNotificationAvatarEmilyBlunt = () => merchantNotificationAvatarEmilyBlunt;

export const getMerchantNotificationAvatarMarcusAurelius = () =>
  merchantNotificationAvatarMarcusAurelius;

export const MERCHANT_SOCIALS_EMPTY_ICONS = merchantSocialsEmptyIcons;

export const MERCHANT_TEAM_EMPTY_AVATARS = [
  merchantTeamEmptyAvatar1,
  merchantTeamEmptyAvatar2,
  merchantTeamEmptyAvatar3,
  merchantTeamEmptyAvatar4,
];
